export default __webpack_public_path__ + "media/icons/profile-icon-active-6107ab20.svg";